import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    Checkbox,
    FormControlLabel,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddFee({ open, onClose, setOpen }: ModalProps) {
    const [feeType, setFeeType] = useState("Percentage");
    const [appliedTo, setAppliedTo] = useState("Product");

    const handleFeeTypeChange = (event: SelectChangeEvent) => {
        setFeeType(event.target.value);
    };

    const handleAppliedToChange = (event: SelectChangeEvent) => {
        setAppliedTo(event.target.value);
    };

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Edit Fee</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">
                            {/* Fee Name */}
                            <div className="control_group w_100">
                                <label htmlFor="fee-name">Fee Name</label>
                                <TextField
                                    placeholder="Enter Fee Name"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "fee-name" }}
                                />
                            </div>

                            {/* Fee Type */}
                            <div className="control_group w_50">
                                <label htmlFor="fee-type">Fee Type</label>
                                <Select
                                    fullWidth
                                    value={feeType}
                                    onChange={handleFeeTypeChange}
                                    inputProps={{ id: "fee-type" }}
                                >
                                    <MenuItem value="Percentage">Percentage</MenuItem>
                                    <MenuItem value="Flat">Flat</MenuItem>
                                </Select>
                            </div>

                            {/* Value */}
                            <div className="control_group w_50">
                                <label htmlFor="fee-amount">Value</label>
                                <TextField
                                    type="number"
                                    placeholder="0"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "fee-amount" }}
                                />
                            </div>

                            {/* Applied To */}
                            <div className="control_group w_100">
                                <label htmlFor="applied-to">Applied To</label>
                                <Select
                                    fullWidth
                                    value={appliedTo}
                                    onChange={handleAppliedToChange}
                                    inputProps={{ id: "applied-to" }}
                                >
                                    <MenuItem value="Product">Product</MenuItem>
                                    <MenuItem value="Services">Services</MenuItem>
                                </Select>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
